import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'rr0091',
    ecrans: ['00-2']
});
